export default __webpack_public_path__ + "static/media/kia.79706532.jpg";